import { BoundariesContext } from 'contexts/popover';
import { FC, ReactNode, useRef } from 'react';

interface SidePanelContainerProps {
  children: ReactNode;
  sidePanel: ReactNode;
  topBar?: ReactNode;
}

export const SidePanelContainer: FC<SidePanelContainerProps> = ({ children, sidePanel, topBar }) => {
  const sidePanelRef = useRef<HTMLDivElement>(null);

  return (
    <BoundariesContext.Provider value={sidePanelRef.current ?? undefined}>
      <div className="quote-form-container overflow-hidden position-relative">
        {children && (
          <div className="main-form d-flex flex-column pb-0 standard-side-panel overflow-x-auto">
            {topBar}
            {children}
          </div>
        )}
        {sidePanel && (
          <div
            ref={sidePanelRef}
            className="side-panel animate-side-panel h-100 layout-standard overflow-auto"
            data-e2e="side-panel"
          >
            {sidePanel}
          </div>
        )}
      </div>
    </BoundariesContext.Provider>
  );
};

SidePanelContainer.displayName = 'SidePanelContainer';
